import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colorBorder, colorBackground, colorHover } from '@/utils/palette';
import { left } from '@/utils/directions';
import SidebarLink, { SidebarLinkTitle } from './SidebarLink';
import SidebarCategory from './SidebarCategory';
import { AuthContext } from '../../../../context/AuthContext';
import { PermissionContext } from '../../../../context/PermissionContext';

const SidebarContent = ({
  onClick, collapse,
}) => {
  // const [userID, setUserID] = useState();
  const {
 statusCode, type,
} = useContext(AuthContext);
  const { permissionsAccess } = useContext(PermissionContext);




 
  return (
    <SidebarContentWrap 
      collapse={collapse}
    >
      <SidebarBlock collapse={collapse}>
    
        
       
        <SidebarLink
          title="App Dashboard"
          icon="smartphone"
          route="/dashboard"
          onClick={onClick}
        />
       
        
      
      </SidebarBlock>
      {/* <SidebarBlock collapse={collapse} /> */}
      
      {statusCode === '1' && (
      <SidebarBlock collapse={collapse}>

          
        {type === '0' && (
          <SidebarLink title="Profile" icon="user" route="/agent/Profile" onClick={onClick} />
        )}

       
         

        {
                  permissionsAccess?.length > 0
                  && permissionsAccess[0]?.master_id === '1'
                  && permissionsAccess[0]?.view === 1 && (
                    <SidebarLink title="Meal" icon="dinner" route="/agent/meal" onClick={onClick} />
                  ) 
                }
        {
                  permissionsAccess?.length > 0
                  && permissionsAccess[1]?.master_id === '2'
                  && permissionsAccess[1]?.view === 1 && (
                    <SidebarLink 
                      title="Booking" 
                      icon="list"
                      route="/agent/booking"
                      onClick={onClick}
                    />
                  ) 
                }


        {
                  permissionsAccess?.length > 0
                  && permissionsAccess[3]?.master_id === '4'
                  && permissionsAccess[3]?.view === 1 && (     
                  <SidebarLink 
                    title="Trip" 
                    icon="earth"
                    route="/agent/trip"
                    onClick={onClick}
                  />
      ) 
    }
        {
                  permissionsAccess?.length > 0
                  && permissionsAccess[2]?.master_id === '3'
                  && permissionsAccess[2]?.view === 1 && (
                    <SidebarLink 
                      title="Account" 
                      icon="chart-bars"
                      route="/agent/account"
                      onClick={onClick}
                    />
                  ) 
                }

       

        {permissionsAccess?.[2]?.master_id === '3'
                        && permissionsAccess?.[2]?.approval === 1 && (
                          <SidebarCategory title="Payment Approval" icon="checkmark-circle" collapse={collapse}>
                            <SidebarLink
                              title="Approved"
                              icon="thumbs-up"
                              color="green"
                              route="/agent/payment/approved"
                              onClick={onClick}
                            />
                            <SidebarLink
                              title="Pending" 
                              icon="warning"
                              color="orange"
                              route="/agent/payment/pending"
                              onClick={onClick}
                            />
                            <SidebarLink
                              title="Rejected" 
                              icon="cross"
                              color="red"
                              route="/agent/payment/reject"
                              onClick={onClick}
                            />
                          </SidebarCategory>
                        )}

        {type === '0' && (
        <SidebarCategory title="User Manager" icon="user" collapse={collapse}>
          <SidebarLink 
            title="Users" 
            icon="users" 
            route="/usermanager/users" 
            onClick={onClick}
          />
          <SidebarLink 
            title="Users Management" 
            icon="database" 
            route="/usermanager/manager" 
            onClick={onClick}
          />
        </SidebarCategory>
      )}
       
       
        


   
        
        
        
       
      </SidebarBlock>
       )} 
     
      
    </SidebarContentWrap>
  );
};

SidebarContent.propTypes = {
  onClick: PropTypes.func,
  collapse: PropTypes.bool,
};

SidebarContent.defaultProps = {
  collapse: false,
  onClick: () => {},
};

export default SidebarContent;

// region STYLES

const SidebarContentWrap = styled.div`
  height: 100%;
  overflow: auto;
  padding-top: 0;
  
  & > div:last-child {
    width: 4px !important;

    div {
      transition: height 0.3s;
      opacity: 0.52;
    }
  }
  
  @media screen and (min-width: 576px) {
    padding-top: 15px;
    
    ${props => props.collapse && `
      width: 55px;
      overflow: visible !important;
      transition: width 0.3s;
    `}
  }
`;

const SidebarBlock = styled.ul`
  padding: 15px 0;
  border-bottom: 1px solid ${colorBorder};
  list-style-type: none;
  
  &:last-child {
    border: none;
  }
  
  @media screen and (min-width: 576px) {
    
    ${props => props.collapse && `
      & > li > a,
      & > li > button {
        overflow: hidden;
        width: 55px;
        background: ${colorBackground(props)};
        
        span:last-of-type {
          opacity: 0;
          transition: 0.3s;
        }
  
        ${SidebarLinkTitle} {
          position: absolute;
          width: 160px;
          ${left(props)}: 70px;
        }
  
        &:hover {
          background: ${colorHover(props)};
        }
      }
      
      & > li:hover > a,
      & > li:hover > button {
        width: 275px;
        
        span {
          opacity: 1;
        }
      }
    `}
  }
`;

// endregion

